import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useGeoLocation = () => {
  const key = 'v1/user/geolocation/';
  const { data: geoLocationData, ...rest } = useFetch(key, {
    hostType: HOST_TYPE.LOCATION_HOST
  });
  return { geoLocationData, ...rest };
};

export default useGeoLocation;
